export const AUTH_FREE_ROUTES = ['login', 'questionnaire-json', 'questionnaire1', 'questionnaire2', 'questionnaire3'];